import { jsx } from "panel";
import { BannerSize, BannerTheme } from "common/components/banner/types";
import { BannerEl } from "common/components/banner";
import { DropdownBannerEl } from "common/components/banner/dropdown";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".mp-report-banners", class: { "has-banners": this.helpers.areBannersVisible() } }, this.state.banners.map(
    (banner, bannerIdx) => banner.dropdown ? /* @__PURE__ */ jsx(
      DropdownBannerEl,
      {
        class: { "banner-hidden": !banner.visible || this.state.hiddenBannerIdentifiers.has(banner.identifier) },
        attrs: {
          size: banner.size || BannerSize.Medium,
          theme: banner.type || BannerTheme.Info,
          "header-text": banner.title,
          "body-text": banner.message,
          dropdown: banner.dropdown,
          "banner-tracking-type": banner.trackingType
        }
      }
    ) : /* @__PURE__ */ jsx(
      BannerEl,
      {
        class: { "banner-hidden": !banner.visible || this.state.hiddenBannerIdentifiers.has(banner.identifier) },
        attrs: {
          size: banner.size || BannerSize.Medium,
          theme: banner.type || BannerTheme.Info,
          "header-text": banner.title,
          "body-text": banner.message,
          ctas: banner.ctas,
          "banner-tracking-type": banner.trackingType
        },
        on: {
          action: (ev) => this.helpers.handleBannerAction(ev, bannerIdx)
        }
      }
    )
  ));
}
